import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import { Select } from 'src/components/common/Select';
import { statusOptions } from 'src/components/staticDropdownOptions/options';
import { permitOn } from 'src/components/common/uis';
import QuillViewer from 'src/components/QuillViewer';
import ReactionDescriptionEditor from 'src/apps/mydb/elements/details/reactions/schemeTab/ReactionDescriptionEditor';
import { EditUserLabels } from 'src/components/UserLabels';

export default function ReactionSchemeMetadataSection({
  reaction,
  onInputChange,
  onReactionChange,
  reactionDescTemplate,
  updateTextTemplates,
  reactQuillRef,
}) {
  return (
    <>
      <Row className="my-3">
        <Col sm={8}>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="reaction_name"
              type="text"
              value={reaction.name || ''}
              placeholder="Name..."
              disabled={!permitOn(reaction) || reaction.isMethodDisabled('name')}
              onChange={(event) => onInputChange('name', event)}
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Select
              name="status"
              isClearable
              options={statusOptions}
              value={statusOptions.find(({ value }) => value === reaction.status)}
              isDisabled={!permitOn(reaction) || reaction.isMethodDisabled('status')}
              onChange={(option) => {
                const wrappedEvent = { target: { value: option?.value || null } };
                onInputChange('status', wrappedEvent);
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={12}>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <div>
              {permitOn(reaction)
                ? (
                  <ReactionDescriptionEditor
                    height="100%"
                    reactQuillRef={reactQuillRef}
                    template={reactionDescTemplate}
                    value={reaction.description}
                    updateTextTemplates={updateTextTemplates}
                    onChange={(event) => onInputChange('description', event)}
                  />
                )
                : <QuillViewer value={reaction.description} />}
            </div>
          </Form.Group>
        </Col>
      </Row>

      <div className="mx-0 mt-2">
        <EditUserLabels element={reaction} fnCb={onReactionChange} />
      </div>
    </>
  );
}

ReactionSchemeMetadataSection.propTypes = {
  reaction: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onReactionChange: PropTypes.func.isRequired,
  reactionDescTemplate: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  updateTextTemplates: PropTypes.func.isRequired,
  reactQuillRef: PropTypes.object.isRequired,
};
